import moment from "moment";
import React, { useEffect, useState } from "react";
import { AiFillEye, AiOutlineDownload } from "react-icons/ai";
import PageTitle from "../../../components/partials/PageTitle";
import pdf from "../../../assets/images/img-icons/pdf.png";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import { formatDynamicValues, joinBy_ } from "./CoverInfo";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { flashMessage as flash } from "../../../utils/flash";
import { coverInfoSchema } from "../../../utils/validators/schema";
import RichTextEditor from "../../../components/form/RichTextEditor";
import { dejoinBy_, handleDownload } from "../../../utils/helpers/functions";
import ModalContainer from "../../../components/modals/ModalContainer";
import DeclineClaim from "../../../components/modals/claims/DeclineClaim";
import ApproveClaim from "../../../components/modals/claims/ApproveClaim";
import {
  getSingleClaim,
  getClaimComments,
  resetClaimStatus,
  updateClaim,
} from "../../../redux/slice/claim/claimSlice";
import useFileUpload from "../../../utils/hooks/useFileUpload";
import { LoaderTwo } from "../../../components/loader/LoaderTwo";
import ClaimComment from "../../../components/modals/claims/ClaimComment";
import { resetCustomerSinglePolicyDetailsView } from "../../../redux/slice/policy/policySlice";

const dynamicFields = (dynamic_values) => {
  const objectData = {};
  if (dynamic_values) {
    for (const element of dynamic_values) {
      objectData[element.field_name] = element.value;
    }
    return objectData;
  }
};

const SingleClaim = () => {
  const { single_claim, isSuccess, isUpdated, claim_comments } = useSelector(
    (state) => state.claim
  );
  const {
    policyHolder,
    policy_cover,
    claim_process_settings,
    createSuccess,
    tempCoverInfo,
  } = useSelector((state) => state.claim);
  const { user_role, user_permissions } = useSelector(
    (state) => state?.auth?.user
  );
  const { all_covers } = useSelector((state) => state.cover);

  //   local state variables
  const [hasEditClaim, setHasEditClaim] = useState(null);
  const [commentItem, setCommentItem] = useState(false);
  const [editClaim, setEditClaim] = useState(false);
  const fileTypes = ["JPG", "PNG", "PDF", "DOC", "DOCX"];
  const [isUploading, setIsUploading] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const [detailsOfLoss, setDetailsOfLoss] = useState(
    single_claim?.single_claim_process_details?.details_of_loss
  );
  const [fileList, setFileList] = useState([]);
  const [policyCover, setPolicyCover] = useState("");
  const [disable, setDisable] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();

  const breadcrumb = {
    from: {
      title: "Claims",
      link: "/admin/claims/all-claims",
    },
    current: {
      title: "Claims Process",
      link: null,
    },
  };

  const { fileUrl, singleFileUpload } = useFileUpload();

  // const handleFileChange = (file) => {
  //   setIsUploading(true);
  //   singleFileUpload(file);
  //   setSelectedFile("document-upload");
  // };

  const handleCustomFileChange = (name, e) => {
    e.preventDefault();
    setIsUploading(true);
    singleFileUpload(e.target.files[0]);
    setSelectedFile(name);
  };

  const onSubmit = (values) => {
    if (fileList.length < 1) {
      flash("error", "Document is required");
      return;
    }
    let payload = {
      policy_cover: single_claim?.single_claim_process_details?.policy_cover,
      reason_for_claim: values.reason_for_claim,
      total_premium_paid: values.total_premium_paid,
      claim_amount: values.claim_amount,
      premium_paid_date: values.premium_paid_date,
      date_of_loss: values.date_of_loss,
      documents: fileList,
      policy_id: single_claim?.single_claim_process_details?.policy_id,
      office_id: single_claim?.single_claim_process_details?.cusomer_office_id,
      customer_id: single_claim?.single_claim_process_details?.customerId,
      id: single_claim?.single_claim_process_details?.id,
      policy_app_no:
        single_claim?.single_claim_process_details?.policyAppNumber,
      details_of_loss: detailsOfLoss,
      dynamic_fields: formatDynamicValues(
        values,
        JSON.parse(single_claim?.single_claim_process_details?.dynamic_fields)
      ),
    };

    dispatch(updateClaim(payload));
  };

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    resetForm,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      policy_cover: single_claim?.single_claim_process_details?.policy_cover,
      //   date_of_loss: single_claim?.single_claim_process_details?.date_of_loss,
      premium_paid_date:
        single_claim?.single_claim_process_details?.premium_paid_date,
      claim_amount: single_claim?.single_claim_process_details?.claim_amount,
      total_premium_paid:
        single_claim?.single_claim_process_details?.total_premium_paid,
      reason_for_claim:
        single_claim?.single_claim_process_details?.reason_for_claim,
      date_of_loss: single_claim?.single_claim_process_details?.date_of_loss,
      document: [],
      ...dynamicFields(
        JSON.parse(
          single_claim?.single_claim_process_details?.dynamic_fields
            ? single_claim?.single_claim_process_details?.dynamic_fields
            : "[]"
        )
      ),
    },
    validationSchema: coverInfoSchema,
    validate: (values) => {
      let errors = {};
      let customFormCompulsoryFields =
        claim_process_settings?.get_claim_form?.filter(
          (items) => items?.compulsory_field === 1
        );
      customFormCompulsoryFields?.forEach((field) => {
        const fieldName = joinBy_(field?.field_name);
        const value = values[fieldName];

        if (value === "") {
          errors[fieldName] = fieldName + " is required.";
        }
      });
      //   if (!values?.policy_cover?.value) {
      //     errors.policy_cover = "policy cover is required.";
      //   }
      return errors;
    },

    onSubmit,
  });

  useEffect(() => {
    setDetailsOfLoss(
      single_claim?.single_claim_process_details?.details_of_loss
    );
    setFileList(
      single_claim?.single_claim_process_details?.documents &&
        JSON.parse(single_claim?.single_claim_process_details?.documents)
    );
    dispatch(resetCustomerSinglePolicyDetailsView());
  }, [single_claim]);

  useEffect(() => {
    if (fileUrl && selectedFile !== "document-upload") {
      setFieldValue(selectedFile, fileUrl);
      setSelectedFile(selectedFile);
      setIsUploading(false);
    }
  }, [fileUrl]);

  useEffect(() => {
    // get single claim on page load or reload
    if (!isUpdated) {
      dispatch(getSingleClaim(state?.id));
    }

    if (isUpdated) {
      dispatch(resetClaimStatus());
      navigate("/admin/claims/all-claims");
    }
  }, [isUpdated]);

  useEffect(() => {
    dispatch(
      getClaimComments({
        claim_uuid: single_claim?.single_claim_process_details?.id,
        claim_id: single_claim?.single_claim_process_details?.claim_id,
      })
    );
  }, [
    dispatch,
    single_claim?.single_claim_process_details?.claim_id,
    single_claim?.single_claim_process_details?.id,
  ]);

  useEffect(() => {
    if (
      !user_permissions?.some(
        (permission) => permission.name === "claim module"
      ) ||
      !user_permissions?.some((permission) => permission.name === "view claim")
    ) {
      navigate("/admin/dashboard");
    }

    setHasEditClaim(
      user_permissions?.some((permission) => permission.name === "edit claim")
    );
  }, [navigate, user_permissions]);

  if (!single_claim) {
    return (
      <div className='mt-2'>
        <LoaderTwo />
      </div>
    );
  }

  return (
    <div>
      {/* page title */}
      <PageTitle title='View Claim' breadcrumb={breadcrumb} />
      {/* end page title */}
      <div className='row'>
        <div className='col-md-12'>
          <div className='card p-3'>
            <div>
              <h4 className='text-primary'>Policy Information</h4>
              <div className='row'>
                <div className='col-md-12 col-lg-10'>
                  <div className='row'>
                    <div className='col-md-6 mt-1 '>
                      <span className='fw-bold me-2'>Customer Name: </span>
                      <Link
                        to={`/admin/customer-profile/${single_claim?.customer_id}`}
                      >
                        {single_claim?.single_claim_process_details
                          ?.customerFirstName +
                          " " +
                          single_claim?.single_claim_process_details
                            ?.customerLastName}
                      </Link>
                    </div>
                    <div className='col-md-6 mt-2'>
                      <span className='fw-bold me-2'>Customer Id: </span>
                      <span>
                        {single_claim?.single_claim_process_details?.customerId}
                      </span>
                    </div>
                    <div className='col-md-6 mt-2'>
                      <span className='fw-bold me-2'>Marketer/Agent: </span>
                      <span>
                        {single_claim?.single_claim_process_details
                          ?.agentFirstName +
                          single_claim?.single_claim_process_details
                            ?.agentLastName}
                      </span>
                    </div>
                    <div className='col-md-6 mt-2 '>
                      <span className='fw-bold me-2'>Policy No: </span>
                      <Link
                        to={`/admin/customer-policy-view`}
                        state={{
                          customerId:
                            single_claim?.single_claim_process_details
                              ?.customerId,
                          policyAppNumber:
                            single_claim?.single_claim_process_details
                              ?.policyAppNumber,
                        }}
                      >
                        {
                          single_claim?.single_claim_process_details
                            ?.policyAppNumber
                        }
                      </Link>
                    </div>
                    <div className='col-md-6 mt-2'>
                      <span className='fw-bold me-2'>Policy Name: </span>
                      <span>
                        {single_claim?.single_claim_process_details?.policyName}
                      </span>
                      {/* <span>{policyHolder?.policyName}</span> */}
                    </div>
                    <div className='col-md-6 mt-2'>
                      <span className='fw-bold me-2'>Status: </span>
                      {single_claim?.single_claim_process_details?.status ? (
                        <>
                          <span className='badge badge-success-lighten'>
                            {single_claim?.single_claim_process_details
                              ?.status === "2" && "Active"}
                          </span>
                          <span className='badge badge-warning-lighten'>
                            {single_claim?.single_claim_process_details
                              ?.status === "1" && "Pending"}
                          </span>
                          <span className='badge badge-info-lighten'>
                            {single_claim?.single_claim_process_details
                              ?.status === "3" && "Matured"}
                          </span>
                          <span className='badge badge-danger-lighten'>
                            {single_claim?.single_claim_process_details
                              ?.status === "4" && "Claim Processed"}
                          </span>
                        </>
                      ) : null}
                    </div>
                    <div className='col-md-6 mt-2'>
                      <span className='fw-bold me-2'>Duration: </span>
                      <span>
                        {single_claim?.single_claim_process_details?.duration
                          ? single_claim?.single_claim_process_details
                              ?.duration + "months"
                          : null}
                      </span>
                    </div>
                    <div className='col-md-6 mt-2'>
                      <span className='fw-bold me-2'>Discount: </span>
                      <span>
                        {single_claim?.single_claim_process_details?.discount
                          ? single_claim?.single_claim_process_details
                              ?.discount + "%"
                          : "Nil"}
                      </span>
                    </div>
                    <div className='col-md-6 mt-2'>
                      <span className='fw-bold me-2'>End Date: </span>
                      <span>
                        {moment(
                          single_claim?.single_claim_process_details?.endDate
                        ).format("LL")}
                      </span>
                    </div>
                    <div className='col-md-6 mt-2'>
                      <span className='fw-bold me-2'>Effective Date: </span>
                      <span>
                        {moment(
                          single_claim?.single_claim_process_details
                            ?.effectiveDate
                        ).format("LL")}
                      </span>
                    </div>
                    <div className='col-md-6 mt-2'>
                      <span className='fw-bold me-2'>Total Premium: </span>
                      <span>
                        &#8358;
                        {
                          single_claim?.single_claim_process_details
                            ?.totalPremium
                        }
                      </span>
                    </div>
                    <div className='col-md-6 mt-2'>
                      <span className='fw-bold me-2'>But-Charge: </span>
                      {single_claim?.single_claim_process_details?.butCharge ? (
                        <span>
                          &#8358;{" "}
                          {
                            single_claim?.single_claim_process_details
                              ?.butCharge
                          }
                        </span>
                      ) : (
                        "Nil"
                      )}
                    </div>
                    <div className='col-md-6 mt-2'>
                      <span className='fw-bold me-2'>Renewal Date: </span>
                      <span>
                        {moment(
                          single_claim?.single_claim_process_details?.endDate
                        ).format("LL")}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <form onSubmit={handleSubmit}>
              <div className='pt-3'>
                <h4 className='text-primary'>Claims Information</h4>
                <div className='row'>
                  <div className='col-md-4'>
                    <label htmlFor='firstName ' className='fw-bold pb-1'>
                      Claim Number
                    </label>
                    <p className='text-capitalize'>
                      {single_claim?.single_claim_process_details?.claim_id}
                    </p>
                  </div>
                  <div className='col-md-4'>
                    <label htmlFor='firstName ' className='fw-bold pb-1'>
                      Policy Cover
                    </label>
                    <p className='text-capitalize'>
                      {
                        all_covers?.unpaginated_cover?.filter(
                          (cover) =>
                            String(
                              single_claim?.single_claim_process_details
                                ?.policy_cover
                            ) === String(cover.id)
                        )[0].name
                      }
                    </p>
                  </div>
                  <div className='col-md-4'></div>
                </div>
                <div className='row mt-2'>
                  <div className='col-md-4'>
                    <label htmlFor='firstName ' className='fw-bold pb-1'>
                      Claim Amount
                    </label>
                    {editClaim ? (
                      <div className='mb-2'>
                        <input
                          type='number'
                          name='claim_amount'
                          id='claim_amount'
                          value={values.claim_amount}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-control form-control-sm ${
                            errors.claim_amount &&
                            touched.claim_amount &&
                            "is-invalid"
                          }`}
                        />
                        {errors.claim_amount && touched.claim_amount ? (
                          <span className='fs-5 invalid-feedback'>
                            {errors.claim_amount}
                          </span>
                        ) : null}
                      </div>
                    ) : (
                      <p className='form-control border-0 shadow'>
                        {
                          single_claim?.single_claim_process_details
                            ?.claim_amount
                        }
                      </p>
                    )}
                  </div>
                  <div className='col-md-4'>
                    <label htmlFor='firstName ' className='fw-bold pb-1'>
                      Total Premium Paid
                    </label>
                    {editClaim ? (
                      <div className='mb-2'>
                        <input
                          type='number'
                          disabled
                          name='total_premium_paid'
                          id='total_premium_paid'
                          value={values.total_premium_paid}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-control form-control-sm ${
                            errors.total_premium_paid &&
                            touched.total_premium_paid &&
                            "is-invalid"
                          }`}
                        />
                        {errors.total_premium_paid &&
                        touched.total_premium_paid ? (
                          <span className='fs-5 invalid-feedback'>
                            {errors.total_premium_paid}
                          </span>
                        ) : null}
                      </div>
                    ) : (
                      <p className='form-control border-0 shadow'>
                        {
                          single_claim?.single_claim_process_details
                            ?.total_premium_paid
                        }
                      </p>
                    )}
                  </div>
                  <div className='col-md-4'>
                    <label htmlFor='firstName ' className='fw-bold pb-1'>
                      Last Premium Paid Date
                    </label>
                    {editClaim ? (
                      <div className='mb-2'>
                        <input
                          type='date'
                          className={`form-control form-control-sm ${
                            errors.premium_paid_date &&
                            touched.premium_paid_date &&
                            "is-invalid"
                          }`}
                          name='premium_paid_date'
                          id='premium_paid_date'
                          disabled
                          value={values.premium_paid_date}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.premium_paid_date &&
                        touched.premium_paid_date ? (
                          <span className='fs-5 invalid-feedback'>
                            {errors.premium_paid_date}
                          </span>
                        ) : null}
                      </div>
                    ) : (
                      <p className='form-control border-0 shadow'>
                        {moment(
                          single_claim?.single_claim_process_details
                            ?.premium_paid_date
                        ).format("D-MM-YYYY")}
                      </p>
                    )}
                  </div>
                  <div className='col-md-4'>
                    <label htmlFor='firstName ' className='fw-bold pb-1'>
                      Reason for Claim
                    </label>
                    {editClaim ? (
                      <div className='mb-2'>
                        <input
                          onChange={handleChange}
                          onBlur={handleBlur}
                          name='reason_for_claim'
                          value={values.reason_for_claim}
                          id='reason_for_claim'
                          className={`form-control form-control-sm ${
                            errors.reason_for_claim &&
                            touched.reason_for_claim &&
                            "is-invalid"
                          }`}
                        />
                        {errors.reason_for_claim && touched.reason_for_claim ? (
                          <span className='fs-5 invalid-feedback'>
                            {errors.reason_for_claim}
                          </span>
                        ) : null}
                      </div>
                    ) : (
                      <p className='form-control border-0 shadow'>
                        {
                          single_claim?.single_claim_process_details
                            ?.reason_for_claim
                        }
                      </p>
                    )}
                  </div>
                  <div className='col-md-4'>
                    <label htmlFor='firstName ' className='fw-bold pb-1'>
                      Date of Loss
                    </label>
                    {editClaim ? (
                      <div>
                        {" "}
                        <input
                          type='date'
                          name='date_of_loss'
                          id='date_of_loss'
                          value={values.date_of_loss}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-control form-control-sm ${
                            errors.date_of_loss &&
                            touched.date_of_loss &&
                            "is-invalid"
                          }`}
                        />
                        {errors.date_of_loss && touched.date_of_loss ? (
                          <span className='fs-5 invalid-feedback'>
                            {errors.date_of_loss}
                          </span>
                        ) : null}
                      </div>
                    ) : (
                      <p className='form-control border-0 shadow'>
                        {
                          single_claim?.single_claim_process_details
                            ?.date_of_loss
                        }
                      </p>
                    )}
                  </div>
                  <div className='col-md-12'>
                    <label htmlFor='firstName ' className='fw-bold pb-1 mt-2'>
                      Details of Loss
                    </label>
                    {editClaim ? (
                      <div className='mb-3' style={{ height: "250px" }}>
                        <RichTextEditor
                          name='details_of_loss'
                          id='details_of_loss'
                          value={detailsOfLoss}
                          onChange={(value) => setDetailsOfLoss(value)}
                          height='200px'
                        />
                      </div>
                    ) : (
                      <div className='form-control border-0 shadow py-2 px-2'>
                        <div
                          dangerouslySetInnerHTML={{
                            __html:
                              single_claim?.single_claim_process_details
                                ?.details_of_loss,
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className=''>
                {!editClaim && (
                  <>
                    <h4 className='pt-3 text-primary'>Documents</h4>
                    <div>
                      {fileList?.length &&
                        fileList?.map((item, index) => (
                          <div
                            key={index + "document"}
                            className='d-flex justify-content-between align-items-center form-control shadow border-0'
                          >
                            <span>
                              {index + 1}. Document-{index + 1}
                            </span>
                            <div className='d-flex align-items-center gap-2 text-primary'>
                              <span
                                onClick={() => handleDownload(item, index + 1)}
                                className='cursor-p'
                              >
                                <AiOutlineDownload size={20} />
                              </span>
                              <a href={item} target='_blank'>
                                <AiFillEye size={20} />
                              </a>
                            </div>
                          </div>
                        ))}
                    </div>
                  </>
                )}
              </div>
              <div className='pt-3'>
                <h4 className='text-primary'></h4>
                <div className='row'>
                  {single_claim?.single_claim_process_details &&
                    JSON.parse(
                      single_claim?.single_claim_process_details?.dynamic_fields
                    )?.map((customForm, index) => {
                      return (
                        <div className='mb-3 col-sm-9 col-md-7' key={index}>
                          {/* For inputs that are not checkbox or file or button */}
                          {customForm?.field_type !== "checkbox" &&
                          customForm?.field_type !== "file" &&
                          customForm?.field_type !== "button" ? (
                            <div>
                              <label
                                htmlFor='firstName '
                                className='fw-bold pb-1'
                              >
                                {dejoinBy_(customForm?.field_name)}
                              </label>

                              {editClaim ? (
                                <>
                                  <span>
                                    {customForm?.compulsory_field === 1 ? (
                                      <span className='text-danger ms-1'>
                                        *
                                      </span>
                                    ) : null}
                                  </span>
                                  <div>
                                    <input
                                      type={`${customForm?.field_type}`}
                                      name={`${joinBy_(
                                        customForm?.field_name
                                      )}`}
                                      className={`form-control form-control-sm`}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      autoComplete='off'
                                      value={
                                        values[joinBy_(customForm?.field_name)]
                                      }
                                    />
                                  </div>
                                  {customForm?.compulsory_field === 1 &&
                                  errors[joinBy_(customForm.field_name)] &&
                                  touched[joinBy_(customForm.field_name)] ? (
                                    <span className='text-danger'>
                                      {customForm.field_name} is required
                                    </span>
                                  ) : null}
                                </>
                              ) : (
                                <>
                                  <p className='form-control border-0 shadow'>
                                    {customForm?.value}
                                  </p>
                                </>
                              )}
                            </div>
                          ) : null}

                          {/* For checkbox input */}
                          {customForm?.field_type === "checkbox" && (
                            <div>
                              <div class='form-check'>
                                {editClaim ? (
                                  <input
                                    class={`form-check-input ${
                                      errors[joinBy_(customForm?.field_name)] &&
                                      touched[joinBy_(customForm?.field_name)]
                                    } `}
                                    type='checkbox'
                                    name={`${joinBy_(customForm?.field_name)}`}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    defaultChecked={
                                      values[
                                        joinBy_(customForm?.field_name)
                                      ][0] &&
                                      values[
                                        joinBy_(customForm?.field_name)
                                      ][0] === "on"
                                    }
                                  />
                                ) : (
                                  <input
                                    class={`form-check-input`}
                                    type='checkbox'
                                    checked={customForm?.value[0]}
                                  />
                                )}
                                <label
                                  className='form-check-label fw-bold'
                                  htmlFor='flexCheckDefault'
                                  style={{ marginTop: "2px" }}
                                >
                                  {dejoinBy_(customForm?.field_name)}
                                </label>

                                {customForm?.compulsory_field === 1 && (
                                  <span className='text-danger ms-1'>*</span>
                                )}
                              </div>
                            </div>
                          )}
                          {/* For file inputs */}
                          {customForm?.field_type === "file" ? (
                            <div>
                              <label htmlFor='' className='fw-bold pb-1 me-1'>
                                {dejoinBy_(customForm?.field_name)}
                              </label>
                              {isUploading && (
                                <span>
                                  <i className='mdi mdi-dots-circle mdi-spin'></i>{" "}
                                </span>
                              )}
                              {values[customForm?.field_name] &&
                                !isUploading &&
                                selectedFile === "document-upload" && (
                                  <span>
                                    <i className='mdi mdi-check'></i>
                                  </span>
                                )}
                              {customForm?.value &&
                                selectedFile === customForm?.field_name &&
                                !isUploading && (
                                  <span>
                                    <i className='mdi mdi-check'></i>
                                  </span>
                                )}
                              {editClaim ? (
                                <>
                                  {customForm?.compulsory_field === 1 && (
                                    <span className='text-danger ms-1'>*</span>
                                  )}
                                  <div>
                                    <input
                                      type={`${customForm?.field_type}`}
                                      name={`${joinBy_(
                                        customForm?.field_name
                                      )}`}
                                      accept='.pdf, image/*'
                                      className={`form-control form-control-sm`}
                                      onChange={(e) =>
                                        handleCustomFileChange(
                                          `${joinBy_(customForm?.field_name)}`,
                                          e
                                        )
                                      }
                                      onBlur={handleBlur}
                                    />
                                    {customForm?.compulsory_field === 1 &&
                                    errors[joinBy_(customForm.field_name)] &&
                                    touched[joinBy_(customForm.field_name)] ? (
                                      <span className='text-danger'>
                                        {customForm.field_name} is required
                                      </span>
                                    ) : null}
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className='d-flex justify-content-between align-items-center form-control shadow border-0'>
                                    <span>
                                      Download/View {customForm?.field_name}
                                    </span>
                                    <div className='d-flex align-items-center gap-2 text-primary'>
                                      <span
                                        onClick={() =>
                                          handleDownload(
                                            customForm?.value,
                                            customForm?.field_name
                                          )
                                        }
                                        className='cursor-p'
                                      >
                                        <AiOutlineDownload size={20} />
                                      </span>
                                      <a
                                        href={customForm?.value}
                                        target='_blank'
                                      >
                                        <AiFillEye size={20} />
                                      </a>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          ) : null}
                        </div>
                      );
                    })}
                </div>
              </div>
              <div className=''>
                {claim_comments?.length > 0 && (
                  <>
                    <h4 className='pt-3 text-primary'>Comments</h4>
                    <div>
                      {claim_comments?.map((item, index) => (
                        <div
                          key={index}
                          className='d-flex justify-content-between align-items-center form-control shadow border-0 mb-2 w-50'
                        >
                          <span>{item.user_role}</span>
                          <div
                            className='text-primary cursor-p'
                            onClick={() => {
                              setCommentItem(item);
                            }}
                            data-bs-toggle='modal'
                            data-bs-target='#comment_view'
                          >
                            <span>
                              <AiFillEye size={20} />
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
              <div className='pt-3 d-flex align-items-center gap-2'>
                {editClaim ? (
                  <div className='d-flex gap-2'>
                    <button
                      type='button'
                      className='btn btn-sm btn-secondary text-white'
                      onClick={() => {
                        setEditClaim(!editClaim);
                        resetForm();
                      }}
                    >
                      Close
                    </button>
                    <button
                      type='submit'
                      className='btn btn-sm btn-primary text-white '
                    >
                      Save
                    </button>
                  </div>
                ) : (
                  <div className='d-flex gap-2'>
                    {hasEditClaim &&
                      single_claim?.single_claim_process_details
                        ?.claim_status !== "1" && (
                        <button
                          type='button'
                          className='btn btn-sm btn-warning text-white'
                          onClick={() => setEditClaim(!editClaim)}
                        >
                          Edit
                        </button>
                      )}
                    {single_claim?.single_claim_process_details
                      ?.claim_status !== "1" &&
                      single_claim?.single_claim_process_details
                        ?.decline_status === "0" &&
                      user_role.some(
                        (role) =>
                          role.name ===
                          single_claim?.single_claim_process_details
                            ?.awaiting_status
                      ) && (
                        <div className='d-flex align-items-center gap-2'>
                          <button
                            className='btn btn-sm btn-danger'
                            data-bs-toggle='modal'
                            data-bs-target='#decline_claim'
                            type='button'
                          >
                            Decline
                          </button>
                          <button
                            className='btn btn-sm btn-success'
                            data-bs-toggle='modal'
                            data-bs-target='#approve_claim'
                            type='button'
                          >
                            Approve
                          </button>
                        </div>
                      )}
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
        <ModalContainer
          modal_id='decline_claim'
          modal_width='modal-md'
          bradius='rounded-2'
        >
          <DeclineClaim
            claim_process_uuid={single_claim?.single_claim_process_details?.id}
            claim_id={single_claim?.single_claim_process_details?.claim_id}
            awaiting_status={
              single_claim?.single_claim_process_details?.awaiting_status
            }
          />
        </ModalContainer>
        <ModalContainer
          modal_id='approve_claim'
          modal_width='modal-md'
          bradius='rounded-2'
        >
          <ApproveClaim
            claim_details={single_claim?.single_claim_process_details}
          />
        </ModalContainer>
        <ModalContainer
          modal_id='comment_view'
          modal_width='modal-md'
          bradius='rounded-2'
        >
          <ClaimComment data={commentItem || []} />
        </ModalContainer>
      </div>
    </div>
  );
};

export default SingleClaim;
